import React, { useRef, useState, useEffect } from 'react';
import ProTable from '@ant-design/pro-table';
import ProList from '@ant-design/pro-list';
import {
  Tag,
  message,
  Modal,
  Divider,
  Space,
  Button,
  Input,
  Select,
  Form,
  Radio,
} from 'antd';

/* 单条消息的渲染抽到了共用组件：商家洞察「查看证据」弹窗要用同一套展示。
   改这里之前先看 ChatMessageItem 的文件头。 */
import ChatMessageItem from '@/components/ChatMessageItem';
import { getMessageList, saveMessageTemplate } from '@/services/message';
import {
  getChartIdList,
  manualSendRpaMessage,
  getChartList,
  getGroupChatListByTenant,
} from '@/services/userManager';

const { TextArea } = Input;

const TYPE_RPA_WORD = 6; // RPA文本
const TYPE_RPA_MINI = 7; // RPA小程序
const TYPE_RPA_PIC = 8; // RPA图片

const ChatListView = (props) => {
  // eslint-disable-next-line react/prop-types
  const { userId } = props;
  // eslint-disable-next-line react/prop-types
  const { tenantId } = props;
  // eslint-disable-next-line react/prop-types
  const { userType } = props; //  1: 用户 ，2:的时候，表示商家下的某个具体教练
  // eslint-disable-next-line react/prop-types
  const { chatId: externalChatId } = props; // 新增：接收外部传入的chatId
  // eslint-disable-next-line react/prop-types
  const { startTime, endTime } = props; // 新增：接收时间筛选参数

  // 会话列表
  const chartListRef = useRef();
  const [chatId, setChatId] = useState(externalChatId || ''); // 修改：优先使用外部传入的chatId
  const [chartIdList, setChartIdList] = useState([]);
  const [chartContent, setChartContent] = useState('');
  const [chartMsgModaVisable, setChartMsgModaVisable] = useState(false);
  const [chartRpaType, setChartRpaType] = useState(0);
  const [chartSelectRowKeys, setChartSelectRowKeys] = useState([]);

  const [releaseForm] = Form.useForm();
  const [modalVisible, setModalVisible] = useState(false);
  const [currentRecord, setCurrentRecord] = useState({});

  // 居中
  const tailLayout = {
    wrapperCol: { offset: 8, span: 16 },
  };
  const layout = {
    // 标签长度
    labelCol: {
      span: 4,
    },
    // 表单长度
    wrapperCol: {
      span: 20,
    },
  };
  // 钩子函数
  useEffect(() => {
    // 如果有外部传入的chatId，直接使用，否则调用API获取
    if (externalChatId) {
      setChatId(externalChatId);
    } else {
      getChartContent();
    }
    /* 依赖必须包含身份参数：教练场景走的是 {userId, userType} 分支（外部不传 chatId、
       也不传 tenantId），原先只依赖 externalChatId，导致切换教练时会话记录不重取。 */
  }, [externalChatId, userId, tenantId, userType]);

  // 获取chart内容
  const getChartContent = () => {
    // 如果有外部传入的chatId，不需要调用API
    if (externalChatId) {
      return;
    }

    if (tenantId) {
      const params = {
        requestData: {
          tenantId,
        },
      };
      getGroupChatListByTenant(params).then((res) => {
        if (res?.code === '00000') {
          if (res?.data != null && res?.data?.length > 0) {
            // 取第一条内容
            setChatId(res?.data[0]?.chatId);
            setChartIdList(res?.data);
            // 切到会话记录时刷新
            chartListRef?.current?.reloadAndRest();
          }
        } else {
          message.error(res?.msg);
        }
      });
    } else {
      const params = {
        requestData: {
          userId: userId,
          userType: userType,
        },
      };
      getChartIdList(params).then((res) => {
        if (res?.code === '00000') {
          if (res?.data != null && res?.data?.length > 0) {
            // 取第一条内容
            setChatId(res?.data[0]?.chatId);
            setChartIdList(res?.data);
            // 切到会话记录时刷新
            chartListRef?.current?.reloadAndRest();
          }
        } else {
          message.error(res?.msg);
        }
      });
    }
  };

  const onChartSelect = (value) => {
    setChatId(value);
    // 切到会话记录时刷新
    chartListRef?.current?.reloadAndRest();
  };
  // 标签输入框监听
  const onChartContentChange = (e, params) => {
    const value = e.target.value;
    setChartContent(value);
  };
  const onChartSendClick = (type) => {
    const requestData = {};
    requestData.userId = userId;
    requestData.chatId = chatId;
    if (type === TYPE_RPA_WORD) {
      requestData.text = chartContent;
    } else {
      requestData.materialIdList = chartSelectRowKeys;
    }

    const params = {
      requestData: requestData,
    };
    manualSendRpaMessage(params).then((res) => {
      if (res.code === '00000') {
        setChartSelectRowKeys([]);
        setChartMsgModaVisable(false);
        chartListRef?.current?.reloadAndRest();
      } else {
        message.error(res.msg);
      }
    });
  };

  const onChartPicClick = () => {
    setChartRpaType(TYPE_RPA_PIC);
    setChartMsgModaVisable(true);
  };

  const onChartMiniClick = () => {
    setChartRpaType(TYPE_RPA_MINI);
    setChartMsgModaVisable(true);
  };

  const onChartCancle = () => {
    setChartMsgModaVisable(false);
    setChartSelectRowKeys([]);
  };

  // 权益发放
  function renderModalCancel() {
    // 清空表单
    releaseForm.resetFields();
    setCurrentRecord({});
    setModalVisible(false);
  }

  function formSubmit() {
    releaseForm.validateFields().then((values) => {
      const param = { ...values };
      param.templateCode = Date.now();
      param.templateName = Date.now();
      param.type = 13;

      param.videoChannel = { ...currentRecord };

      saveMessageTemplate({
        requestData: param,
      }).then(({ code, msg }) => {
        if (code === '00000') {
          message.success('保存成功');
          renderModalCancel();
        } else {
          message.error(msg);
        }
      });
    });
  }

  // 发放权益modal
  function renderModal() {
    return (
      <div>
        <Modal
          title="保存素材"
          visible={modalVisible}
          // onOk={renderModalOK}
          onCancel={renderModalCancel}
          width={1000}
          footer={null}
        >
          <Form
            style={{ marginTop: 30 }}
            form={releaseForm}
            name="edit"
            {...layout}
            // layout="vertical"
          >
            <Form.Item
              label="素材属性"
              name="ownerType"
              rules={[
                {
                  required: true,
                  message: '请选择!',
                },
              ]}
              initialValue={2}
            >
              <Radio.Group>
                <Radio value={1}>平台素材</Radio>
                <Radio value={2}>个人素材</Radio>
              </Radio.Group>
            </Form.Item>

            <Form.Item {...tailLayout}>
              <Space size={100}>
                <Button onClick={renderModalCancel}>取消</Button>
                <Button type="primary" onClick={formSubmit}>
                  确定
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </Modal>
      </div>
    );
  }

  const onChartSelectChange = (newSelectedRowKeys) => {
    console.log('newSelectedRowKeys,', newSelectedRowKeys);
    setChartSelectRowKeys(newSelectedRowKeys);
  };

  // 弹窗素材列表
  const chartMstColumnsPop = [
    {
      title: '类型',
      dataIndex: 'typeName',
      align: 'center',
      valueType: 'select',

      renderFormItem: (item, { type, defaultRender, ...rest }, form) => {
        return (
          <div>
            <Select
              value={chartRpaType === TYPE_RPA_MINI ? 'RPA小程序' : 'RPA图片'}
              disabled
            />
          </div>
        );
      },
    },
    {
      title: '素材名称',
      dataIndex: 'templateName',
      valueType: 'input',

      render: (_, record, index) => {
        return (
          <div>
            <Tag color="#6e75f9">ID {record.id}</Tag>
            {record.templateName}
          </div>
        );
      },
    },
  ];

  const chartSelectMsgModal = () => {
    return (
      <Modal
        title="选择素材"
        visible={chartMsgModaVisable}
        width={1000}
        onCancel={onChartCancle}
        destroyOnClose={true}
        footer={[
          <Button
            style={{
              position: 'relative',
              width: 150,
              height: 44,
              right: 380,
              marginTop: 10,
              marginBottom: 10,
            }}
            key="submit"
            type="primary"
            onClick={() => {
              onChartSendClick(chartRpaType);
            }}
          >
            发送
          </Button>,
          <Button
            style={{ position: 'relative', width: 150, height: 44, right: 280 }}
            key="back"
            onClick={() => {
              onChartCancle();
            }}
          >
            取消
          </Button>,
        ]}
      >
        <ProTable
          columns={chartMstColumnsPop}
          rowKey="id"
          search={{
            labelWidth: '100',
          }}
          scroll={{ x: 'max-content' }}
          toolBarRender={false}
          rowSelection={{
            setChartSelectRowKeys,
            onChange: onChartSelectChange,
            preserveSelectedRowKeys: true,
          }}
          pagination={{
            defaultPageSize: 5,
          }}
          request={async (params) => {
            const { data, page, code } = await getMessageList({
              requestData: {
                ...params,
                type: chartRpaType,
                ownerType: 1,
              },
              page: {
                currentPage: params.current,
                pageSize: params.pageSize,
              },
            });
            if (code !== '00000') {
              return {
                success: false,
              };
            }
            return {
              data: data,
              success: true,
              total: page.count,
            };
          }}
        />
      </Modal>
    );
  };

  return (
    <div>
      {/* 当有外部传入的chatId时，隐藏发送功能 */}
      {!externalChatId && (
        <div style={{ position: 'relative', marginBottom: 10 }}>
          <div
            style={{
              borderColor: '#cccbcc',
              borderWidth: 1,
              borderStyle: 'solid',
              paddingTop: 5,
              paddingBottom: 5,
              borderBottomWidth: 0,
            }}
          >
            <span style={{ color: '#448ef7', marginLeft: 30, marginTop: 5 }}>
              {' '}
              文字
            </span>
            <Button
              type="text"
              style={{ marginLeft: 30 }}
              onClick={onChartPicClick}
            >
              {' '}
              图片
            </Button>
            {userId && (
              <Button
                type="text"
                style={{ marginLeft: 30 }}
                onClick={onChartMiniClick}
              >
                {' '}
                小程序
              </Button>
            )}
          </div>

          <TextArea
            value={chartContent}
            rows={6}
            style={{ minHeight: 100 }}
            placeholder={'支持按下Enter键换行'}
            onChange={(e) => onChartContentChange(e, 'content')}
          ></TextArea>

          <Button
            type="primary"
            style={{ position: 'absolute', bottom: 15, right: 0, width: 84 }}
            onClick={() => {
              onChartSendClick(TYPE_RPA_WORD);
            }}
          >
            发送
          </Button>
        </div>
      )}

      <div>
        <Divider
          type="vertical"
          style={{
            width: 4,
            height: 15,
            background: '#448ef7',
            borderRadius: 5,
          }}
        />
        <span style={{ fontWeight: 'blod' }}>
          {tenantId ? '商家及会员群:' : '专属服务群:'}
        </span>
        {/* 当有外部传入的chatId时，显示固定群名，否则显示选择器 */}
        {externalChatId ? (
          <span style={{ marginLeft: 15, color: '#1890ff' }}>
            {chartIdList.find((item) => item.chatId === externalChatId)?.name ||
              '当前群聊'}
          </span>
        ) : (
          <Select
            placeholder="请选择"
            value={chatId}
            onChange={onChartSelect}
            fieldNames={{
              label: 'name',
              value: 'chatId',
              options: chartIdList,
            }}
            options={chartIdList}
            style={{ width: 300, marginLeft: 15 }}
          >
            {' '}
          </Select>
        )}
      </div>
      <ProList
        toolBarRender={false}
        search={false}
        rowKey="id"
        actionRef={chartListRef}
        itemLayout="vertical"
        headerTitle="基础列表"
        params={{ chatId, startTime, endTime }} // 添加 params 属性以触发重新请求
        request={async (params) => {
          if (!chatId) {
            return;
          }
          const { data, page, code } = await getChartList({
            requestData: {
              userId: userId,
              weComChatId: chatId,
              startTime: params.startTime, // 使用 params 中的 startTime
              endTime: params.endTime, // 使用 params 中的 endTime
            },
            page: {
              currentPage: params.current,
              pageSize: params.pageSize,
            },
          });
          if (code !== '00000') {
            return {
              success: false,
            };
          }

          return {
            data: data,
            success: true,
            total: page.count,
          };
        }}
        pagination={{
          defaultPageSize: 10,
        }}
        showActions="hover"
        metas={{
          content: {
            render: (text, record) => (
              <ChatMessageItem
                record={record}
                onSaveMaterial={(payload) => {
                  setModalVisible(true);
                  setCurrentRecord(payload);
                }}
              />
            ),
          },
        }}
      />
      {chartSelectMsgModal()}
      {renderModal()}
    </div>
  );
};

export default ChatListView;
